<div class="sitemap-overlay" *ngIf="visible" (click)="closeSitemap()"></div>

<div class="sitemap-panel" *ngIf="visible" role="dialog" aria-label="Mapa del sitio">
    <div class="sitemap-header">
        <h2>Estructura de la página</h2>
        <button type="button" class="btn" (click)="closeSitemap()" aria-label="Cerrar mapa del sitio"><i class="fas fa-xmark"></i></button>
    </div>

    <div class="sitemap-tabs">
        <button *ngFor="let tab of tabs" [class.active]="activeTab === tab.id" (click)="activeTab = tab.id">
            {{ tab.label }}
        </button>
    </div>

    <div class="sitemap-content">
        <ul *ngIf="activeTab === 'headings'">
            <li *ngFor="let heading of headings">
                <a (click)="irAHeading(heading.id)"> <i class="fa-solid fa-heading item"></i>{{ heading.text | titlecase }} </a>
            </li>
        </ul>

        <ul *ngIf="activeTab === 'sections'">
            <li *ngFor="let section of sections">
                <a (click)="irAHeading(section.id)"><i class="fa-solid fa-code item"></i>{{ section.text | titlecase }}</a>
            </li>
        </ul>

        <ul *ngIf="activeTab === 'links'">
            <li *ngFor="let l of links">
                <i class="fas fa-link item"></i><a [href]="l.href" target="_blank">{{ l.text }}</a>
            </li>
        </ul>
    </div>
</div>
